/* eslint-env browser */
import React from 'react';
import PopoverInline from './popover-inline';
import PopoverPopper from './popover-popper';
import { getType } from './utils';
import { propTypes, defaultProps, POPOVER_MODE } from './common';

const PopOver = (props) => {
  const type = getType(props);
  if (props.mode === POPOVER_MODE.inline) {
    return <PopoverInline type={type} {...props} />;
  }
  return <PopoverPopper type={type} {...props} />;
};

PopOver.propTypes = propTypes;
PopOver.defaultProps = defaultProps;

export default PopOver;
